import { createActionConst } from '../../../utils/action.utils';

const PROJECT_MEMBER_NAMESPACE = 'PROJECT_MEMBER';

export const STORE_PROJECT_TEAM = createActionConst(PROJECT_MEMBER_NAMESPACE, 'STORE_PROJECT_TEAM');
export const CLEAR_PROJECT_MEMBER = createActionConst(PROJECT_MEMBER_NAMESPACE, 'CLEAR_PROJECT_MEMBER');
